import tacklebox from "tacklebox";

function Pager() {
    tacklebox.design.Pager.call(this, new tacklebox.design.Site("Furbyu", ""), new tacklebox.design.Page(), new tacklebox.design.Auth("", ""));
    this.isDebug = false;
}
tacklebox.design.extend(Pager, tacklebox.design.Pager);
Pager.prototype.toggleDebug = function () {
    this.isDebug = !this.isDebug;
};

export { Pager }